import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SitagLogo from '../../../../inc/assets/images/logo/sitag-logo.png';
import { handleChangeInputLoginPage, handleChangeProfileData, handleChangeToken } from '../../../../redux/actions/pages/user/login';
import { handleChangeInputAddTransPage } from '../../../../redux/actions/pages/trans/addTrans';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { BASE_SITE, VALIDATE_USER_BY_BARCODE, SEND_BUY_CODE_TO_USER, VALIDATE_USER_BY_SMS, ADD_TRANS_POST, PRINT_TRANS_EXTERNAL_LINK } from '../../../../apis';
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import * as qs from "querystring";
import AjaxLoader from '../../../../inc/assets/images/Ajax-loader.gif';
import { Row, Col } from 'react-bootstrap';
import Collapse from '@mui/material/Collapse';

const AddTrans = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

    const { token, profile } = useSelector(state => state.login);
    const { barcode, mobile, code, barcodeBtnDisable, 
                sendSmsBtnDisable, sendSmsBtnTxt, smsBtnDisable, 
                fullname, nationalCode, userCredit, normalCredit, orgCredit, 
                trackingNum, userMobile, userCode, timeRemaining, timerTimeAgain, 
                service, cartAmount, shopShare, cashBackAmount, factorNum, description, 
                addTransBtnDisable, 
                warningWalletShow, requiredSpanShow, warningChargeShow, chargeAmountTxt, 
                visibleSuccessMsg } = useSelector(state => state.addTrans);

    const selectedService = profile.services.filter(serviceItem => serviceItem.id === service);
    useEffect(() => {
        calculate_share(parseInt(removeNonNumeric(changeNumberPersianAndArabic(cartAmount))));
        // eslint-disable-next-line
    }, [service]);


    const [barcodeCollapsed, setBarcodeCollapsed] = React.useState(false);
    const handleBarcodeCollapsed = () => {
        setBarcodeCollapsed((prev) => !prev);
    };

    const [smsCollapsed, setSmsCollapsed] = React.useState(false);
    const handleSmsCollapsed = () => {
        setSmsCollapsed((prev) => !prev);
    };

    const [addFromCollapsed, setAddFormCollapsed] = React.useState(false);
    const handleAddFormCollapsed = () => {
        setAddFormCollapsed((prev) => !prev);
    };

    const [isVisibleAddForm, setIsVisibleAddForm] = useState(false);
    const [isVisibleVerifySmsCode, setIsVisibleVerifySmsCode] = useState(false);



    useEffect(() => {
        handleTimerTime();
        // eslint-disable-next-line
    }, [timeRemaining]);

    let setTimeOut = useRef(null);
    const handleTimerTime = () => {
        if (timeRemaining > 0)
            setTimeOut.current = setTimeout(() => {
                if (timeRemaining > 0) {
                    dispatch(handleChangeInputAddTransPage('timeRemaining', timeRemaining - 1));
                } else {
                    clearTimeout(setTimeOut.current);

                    showVerifyBoxHideAddForm();
                }
            }, 1000);
        else {
            if (timeRemaining !== 0)
                dispatch(handleChangeInputAddTransPage('timeRemaining', 0));
            showVerifyBoxHideAddForm();
        }
    };


    useEffect(() => {
        handleTimerTimeAgain(); /* zamani ke rooye dokmeye ersale code ba sms click mikonim, timeri ke set mikonim vase ersale mojadad az in func estefade mishavad */
        // eslint-disable-next-line
    }, [timerTimeAgain]);


    let setTimeOut2 = useRef(null);
    useEffect(() => {
        /* age eshtebah mobile ro vared karde bashe va bekhad taghir bede, dokme ersal faal beshe */
        reInitializeSendSmsBtn(); 
        
        // eslint-disable-next-line
    }, [mobile]);

    const handleTimerTimeAgain = () => {
        if (timerTimeAgain > 0) {
            setTimeOut2.current  = setTimeout(() => {
                if (timerTimeAgain > 0) {
                    dispatch(handleChangeInputAddTransPage('timerTimeAgain', timerTimeAgain - 1));
                    dispatch(handleChangeInputAddTransPage('sendSmsBtnTxt', `ارسال مجدد  ${timerTimeAgain} ثانیه دیگر`));
                        
                } else {
                    clearTimeout(setTimeOut2.current);

                    reInitializeSendSmsBtn();
                }
            }, 1000);
            // return () => clearTimeout(setTimeOut2);
        }
        else {
            
            reInitializeSendSmsBtn();
        }
    };

    const reInitializeSendSmsBtn = () => {
        clearTimeout(setTimeOut2.current);
        dispatch(handleChangeInputAddTransPage('timerTimeAgain', 0));
        dispatch(handleChangeInputAddTransPage('sendSmsBtnTxt', `ارسال  کد`));
        dispatch(handleChangeInputAddTransPage('sendSmsBtnDisable', false));
    };

    const showVerifyBoxHideAddForm = () => {
        setBarcodeCollapsed(true);
        setSmsCollapsed(true);

        setIsVisibleAddForm(false);
        setAddFormCollapsed(false);
    }



    useEffect(() => {
        setBarcodeCollapsed(true);
        setSmsCollapsed(true);

        if(profile.services !== undefined && profile.services.length > 0)
            dispatch(handleChangeInputAddTransPage('service', profile.services[0].id));
        // eslint-disable-next-line
    }, [AddTrans]);

    const handleNormalInput = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeInputAddTransPage(name, value));
    };

    const handleSubmitFormBarcode = () => {
        if(! barcodeBtnDisable) {
            if(barcode.length === 4) {
                dispatch(handleChangeInputAddTransPage('barcodeBtnDisable', true));

                clearTimeout(setTimeOut.current);

                axios({
                    method: 'post',
                    url: BASE_SITE + VALIDATE_USER_BY_BARCODE,
                    data: qs.stringify({
                        code: barcode,
                    }), headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/x-www-form-urlencoded', 
                        'Authorization': token,
                    },
                }).then((response) => {
                    switch (response.data.status) {
                        case 'error':
                            dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'top', horizontal: 'right'}));
                            break;
                        case 'ok':
                            dispatch(handleChangeInputAddTransPage('userCode', barcode));

                            dispatch(handleChangeInputAddTransPage('barcode', ''));

                            dispatch(handleChangeInputAddTransPage('fullname', response.data.fullname));
                            dispatch(handleChangeInputAddTransPage('nationalCode', response.data.national_code));
                            dispatch(handleChangeInputAddTransPage('userCredit', response.data.user_credit));
                            dispatch(handleChangeInputAddTransPage('normalCredit', response.data.normal_credit));
                            dispatch(handleChangeInputAddTransPage('orgCredit', response.data.org_credit));
                            dispatch(handleChangeInputAddTransPage('trackingNum', response.data.tracking_num));
                            dispatch(handleChangeInputAddTransPage('userMobile', response.data.mobile));
                            dispatch(handleChangeInputAddTransPage('timeRemaining', response.data.time_remaining));

                            setBarcodeCollapsed(false);
                            setSmsCollapsed(false);

                            setIsVisibleAddForm(true);
                            setAddFormCollapsed(true);

                            break;
                        default:
                            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
                    }
                    dispatch(handleChangeInputAddTransPage('barcodeBtnDisable', false));
                }, () => {
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
                    dispatch(handleChangeInputAddTransPage('barcodeBtnDisable', false));
                });
            }
            else
                dispatch(handleSetOpenCustomSnackbar(true, {message: 'بارکد باید 4 رقم باشد!', severity: 'error', vertical: 'top', horizontal: 'right'}));
        }
    };


    const handleBtnSendCodeBySms = () => {
        if(mobile.length === 11) {
            dispatch(handleChangeInputAddTransPage('sendSmsBtnDisable', true));

            axios({
                method: 'post',
                url: BASE_SITE + SEND_BUY_CODE_TO_USER,
                data: qs.stringify({
                    mobile,
                }), headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded', 
                    'Authorization': token,
                },
            }).then((response) => {
                switch (response.data.status) {
                    case 'error':
                        dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'top', horizontal: 'right'}));
                        dispatch(handleChangeInputAddTransPage('sendSmsBtnDisable', false));
                        break;
                    case 'ok':
                        setIsVisibleVerifySmsCode(true);
                        dispatch(handleChangeInputAddTransPage('timerTimeAgain', response.data.timer_time));

                        break;
                    default:
                        dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
                        dispatch(handleChangeInputAddTransPage('sendSmsBtnDisable', false));
                }
            }, () => {
                dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
                dispatch(handleChangeInputAddTransPage('sendSmsBtnDisable', false));
            });
        }
        else
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل باید 11 رقم باشد', severity: 'error', vertical: 'top', horizontal: 'right'}));
    };


    const handleSubmitFormSms = () => {
        if(code.length === 4) {
            dispatch(handleChangeInputAddTransPage('smsBtnDisable', true));

            clearTimeout(setTimeOut.current);

            axios({
                method: 'post',
                url: BASE_SITE + VALIDATE_USER_BY_SMS,
                data: qs.stringify({
                    code,
                    mobile,
                }), headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded', 
                    'Authorization': token,
                },
            }).then((response) => {
                switch (response.data.status) {
                    case 'error':
                        dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'top', horizontal: 'right'}));
                        break;
                    case 'ok':
                        dispatch(handleChangeInputAddTransPage('userCode', code));

                        dispatch(handleChangeInputAddTransPage('mobile', ''));
                        dispatch(handleChangeInputAddTransPage('code', ''));

                        dispatch(handleChangeInputAddTransPage('fullname', response.data.fullname));
                        dispatch(handleChangeInputAddTransPage('nationalCode', response.data.national_code));
                        dispatch(handleChangeInputAddTransPage('userCredit', response.data.user_credit));
                        dispatch(handleChangeInputAddTransPage('normalCredit', response.data.normal_credit));
                        dispatch(handleChangeInputAddTransPage('orgCredit', response.data.org_credit));
                        dispatch(handleChangeInputAddTransPage('trackingNum', response.data.tracking_num));
                        dispatch(handleChangeInputAddTransPage('userMobile', response.data.mobile));
                        dispatch(handleChangeInputAddTransPage('timeRemaining', response.data.time_remaining));

                        setBarcodeCollapsed(false);
                        setSmsCollapsed(false);

                        setIsVisibleAddForm(true);
                        setAddFormCollapsed(true);

                        break;
                    default:
                        dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
                }
                dispatch(handleChangeInputAddTransPage('smsBtnDisable', false));
            }, () => {
                dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
                dispatch(handleChangeInputAddTransPage('smsBtnDisable', false));
            });
        }
        else
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'بارکد باید 4 رقم باشد!', severity: 'error', vertical: 'top', horizontal: 'right'}));
    };



    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }

    const handelNumericInputs = (event) => {
        const {name, value} = event.target;

        dispatch(handleChangeInputAddTransPage(name, addCommas(removeNonNumeric(changeNumberPersianAndArabic(value))) ));

        if(name === 'cartAmount') {
            if(value.length > 0)
                calculate_share(parseInt(removeNonNumeric(changeNumberPersianAndArabic(value))));
            else
                calculate_share(0);
        }
    };

    const calculate_share = (cart_amount) => {
        if(selectedService.length > 0) {
            let shop_share = 0, cash_back = 0, cash_back_org = 0, sitag_fee = 0, sitag_fee_org = 0;
            if(selectedService[0].org_buy === '0') { // forooshe sazmani nadarad
                sitag_fee = Math.ceil(cart_amount * parseFloat(selectedService[0].sitag_fee_percent) / 100);
                cash_back = Math.ceil(cart_amount * parseFloat(selectedService[0].cash_back) / 100);
                shop_share = cart_amount - sitag_fee - cash_back;
                dispatch(handleChangeInputAddTransPage('shopShare', addCommas(shop_share)));
                dispatch(handleChangeInputAddTransPage('cashBackAmount', addCommas(cash_back)));

                if(cart_amount > normalCredit) {
                    dispatch(handleChangeInputAddTransPage('warningWalletShow', true));
                    dispatch(handleChangeInputAddTransPage('requiredSpanShow', true));
                    dispatch(handleChangeInputAddTransPage('warningChargeShow', true));
                    dispatch(handleChangeInputAddTransPage('chargeAmountTxt', (cart_amount - normalCredit).toLocaleString()));
                }
                else {
                    dispatch(handleChangeInputAddTransPage('warningWalletShow', false));
                    dispatch(handleChangeInputAddTransPage('requiredSpanShow', false));
                    dispatch(handleChangeInputAddTransPage('warningChargeShow', false));
                }
            }
            else { // forooshe sazmani dare
                if(cart_amount <= orgCredit) {
                    sitag_fee_org = Math.ceil(cart_amount * parseFloat(selectedService[0].sitag_fee_percent_org) / 100);
                    cash_back_org = Math.ceil(cart_amount * parseFloat(selectedService[0].cash_back_org) / 100);
                    shop_share = cart_amount - sitag_fee_org - cash_back_org;
                    dispatch(handleChangeInputAddTransPage('shopShare', addCommas(shop_share)));
                    dispatch(handleChangeInputAddTransPage('cashBackAmount', addCommas(cash_back_org)));

                    dispatch(handleChangeInputAddTransPage('warningWalletShow', false));
                    dispatch(handleChangeInputAddTransPage('requiredSpanShow', false));
                    dispatch(handleChangeInputAddTransPage('warningChargeShow', false));
                }
                else if(orgCredit > 0) {
                    sitag_fee_org = Math.ceil(orgCredit * parseFloat(selectedService[0].sitag_fee_percent_org) / 100);
                    cash_back_org = Math.ceil(orgCredit * parseFloat(selectedService[0].cash_back_org) / 100);
                    sitag_fee = Math.ceil((cart_amount - orgCredit) * parseFloat(selectedService[0].sitag_fee_percent) / 100);
                    cash_back = Math.ceil((cart_amount - orgCredit) * parseFloat(selectedService[0].percent_cash_back) / 100);
                    shop_share = cart_amount - sitag_fee_org - cash_back_org - sitag_fee - cash_back;
                    dispatch(handleChangeInputAddTransPage('shopShare', addCommas(shop_share)));
                    dispatch(handleChangeInputAddTransPage('cashBackAmount', addCommas(cash_back_org + cash_back)));

                    if(cart_amount > (normalCredit + orgCredit)) {
                        dispatch(handleChangeInputAddTransPage('warningWalletShow', true));
                        dispatch(handleChangeInputAddTransPage('requiredSpanShow', true));
                        dispatch(handleChangeInputAddTransPage('warningChargeShow', true));
                        dispatch(handleChangeInputAddTransPage('chargeAmountTxt', (cart_amount - (normalCredit + orgCredit)).toLocaleString() ));
                    }
                    else {
                        dispatch(handleChangeInputAddTransPage('warningWalletShow', false));
                        dispatch(handleChangeInputAddTransPage('requiredSpanShow', false));
                        dispatch(handleChangeInputAddTransPage('warningChargeShow', false));
                    }
                }
                else {
                    sitag_fee = Math.ceil(cart_amount * parseFloat(selectedService[0].sitag_fee_percent) / 100);
                    cash_back = Math.ceil(cart_amount * parseFloat(selectedService[0].percent_cash_back) / 100);
                    shop_share = cart_amount - sitag_fee - cash_back;
                    dispatch(handleChangeInputAddTransPage('shopShare', addCommas(shop_share)));
                    dispatch(handleChangeInputAddTransPage('cashBackAmount', addCommas(cash_back)));

                    if(cart_amount > normalCredit) {
                        dispatch(handleChangeInputAddTransPage('warningWalletShow', true));
                        dispatch(handleChangeInputAddTransPage('requiredSpanShow', true));
                        dispatch(handleChangeInputAddTransPage('warningChargeShow', true));
                        dispatch(handleChangeInputAddTransPage('chargeAmountTxt', (cart_amount - normalCredit).toLocaleString() ));
                    }
                    else {
                        dispatch(handleChangeInputAddTransPage('warningWalletShow', false));
                        dispatch(handleChangeInputAddTransPage('requiredSpanShow', false));
                        dispatch(handleChangeInputAddTransPage('warningChargeShow', false));
                    }
                }
            }
        }
    };


    const handleSubmitFormAddTrans = () => {
        dispatch(handleChangeInputAddTransPage('addTransBtnDisable', true));

        axios({
            method: 'post',
            url: BASE_SITE + ADD_TRANS_POST,
            data: qs.stringify({
                mobile: userMobile,
                code: userCode,
                cart_amount: removeNonNumeric(cartAmount),
                factor_num: factorNum,
                tracking_num: trackingNum,
                description, 
                service
            }), headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded', 
                'Authorization': token,
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                    dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'top', horizontal: 'right'}));
                    break;
                case 'ok':
                    dispatch(handleChangeInputAddTransPage('barcode', ''));
                    dispatch(handleChangeInputAddTransPage('mobile', ''));

                    dispatch(handleChangeInputAddTransPage('cartAmount', ''));
                    dispatch(handleChangeInputAddTransPage('shopShare', ''));
                    dispatch(handleChangeInputAddTransPage('cashBackAmount', ''));
                    dispatch(handleChangeInputAddTransPage('trackingNum', ''));
                    dispatch(handleChangeInputAddTransPage('factorNum', ''));
                    dispatch(handleChangeInputAddTransPage('description', ''));

                    dispatch(handleChangeInputAddTransPage('fullname', ''));
                    dispatch(handleChangeInputAddTransPage('nationalCode', ''));
                    dispatch(handleChangeInputAddTransPage('userCredit', 0));
                    dispatch(handleChangeInputAddTransPage('normalCredit', 0));
                    dispatch(handleChangeInputAddTransPage('orgCredit', 0));
                    dispatch(handleChangeInputAddTransPage('trackingNum', ''));
                    dispatch(handleChangeInputAddTransPage('userMobile', ''));
                    dispatch(handleChangeInputAddTransPage('timeRemaining', 0));
                    dispatch(handleChangeInputAddTransPage('timeRemaining', 0));
                    dispatch(handleChangeInputAddTransPage('timerTimeAgain', 0));

                    dispatch(handleChangeInputAddTransPage('warningWalletShow', false));
                    dispatch(handleChangeInputAddTransPage('requiredSpanShow', false));

                    dispatch(handleChangeInputAddTransPage('visibleSuccessMsg', true));

                    setBarcodeCollapsed(true);
                    setSmsCollapsed(true);

                    setIsVisibleAddForm(false);
                    setAddFormCollapsed(false);

                    clearTimeout(setTimeOut.current);


                    window.open(`${PRINT_TRANS_EXTERNAL_LINK}${response.data.trans}/${token}`, "_blank");

                    break;
                default:
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
            }
            dispatch(handleChangeInputAddTransPage('addTransBtnDisable', false));
        }, () => {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
            dispatch(handleChangeInputAddTransPage('addTransBtnDisable', false));
        });
    };


    const [isBarcodeBoxHeadingVisible, setIsBarcodeBoxHeadingVisible] = useState(false);
    const [isSmsBoxHeadingVisible, setIsSmsBoxHeadingVisible] = useState(false);
    const [isAddTransBoxHeadingVisible, setIsAddTransBoxHeadingVisible] = useState(false);


    return (


		<div className="app-content content container-fluid">
            <div className="content-wrapper">
                <Row className="content-header">
                </Row>
                <div className="content-body">



                    <Row id="div-success-reg" style={ !visibleSuccessMsg ? {display: 'none'} : null }>
                        <Col className="col-xs-12">
                            <div className="alert alert-success alert-dismissible fade in mb-2 bg-success"
                                 role="alert">
                                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                                تراکنش جدید با موفقیت ثبت شد.
                            </div>
                        </Col>
                    </Row>

                
                    <Row className="content-header mb-1 display-hidden">
                        <Col md={6} xs={12} className="content-header-left mb-1">
                            <h2 className="content-header-title">
                                فرم ثبت  تراکنش
                            </h2>
                        </Col>
                    </Row>


                    <Row >
                        <Col xs={12} md={6} lg={4} >
                            <div className="card" style={{minHeight: 'unset !important'}} >
                                <div className="card-header">
                                    <h4 className="card-title">
                                        اعتبار سنجی از طریق کد خرید
                                    </h4>
                                    <a className="heading-elements-toggle" onClick={() => setIsBarcodeBoxHeadingVisible(! isBarcodeBoxHeadingVisible)}><i className="icon-ellipsis font-medium-3"></i></a>
                                    <div className={`heading-elements ${isBarcodeBoxHeadingVisible ? 'visible' : ''}`}>
                                        <ul className="list-inline mb-0">
                                            <li><a data-action="collapse" id="btn-collapse-expand-box2"><i className={barcodeCollapsed ? "icon-minus4" : "icon-plus4"} onClick={handleBarcodeCollapsed}></i></a></li>
                                            <li><a data-action="expand"><i className="icon-expand2"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <Collapse in={barcodeCollapsed} className="card-body collapse in">
                                    <div className="card-block">
                                        <div className="form-body" style={{overflow: 'unset !important'}} >
                                            <Row >
                                                <Col xs={12} className="col-xs-12">
                                                    <p className="text-muted">
                                                        بارکد روی گوشی کاربر را وارد کنید
                                                    </p>
                                                    <input type="text" name="barcode" className="form-control" placeholder="xxxx"
                                                           id="input-barcode" style={{marginLeft: '15px'}}
                                                           value={barcode} onChange={handleNormalInput} />
                                                    <button type="submit" id="btn-check-barcode" className="btn btn-success w-100 mt-2" name="" value="" disabled={barcodeBtnDisable} onClick={handleSubmitFormBarcode} >تایید
                                                        <img src={AjaxLoader} width="24" id="ajax-loader-btn-check-barcode" className="ml-2" style={ !barcodeBtnDisable ? {display: 'none'} : null} />
                                                    </button>
                                                </Col>
                                            </Row>
                                                    
                                                
                                        </div>
                                    </div>
                                </Collapse>
                            </div>
                        </Col>


                        <Col xs={12} md={6} lg={5}  >
                            <div className="card" style={{minHeight: 'unset !important'}} >
                                <div className="card-header">
                                    <h4 className="card-title">
                                        اعتبار سنجی از طریق پیامک
                                    </h4>
                                    <a className="heading-elements-toggle" onClick={() => setIsSmsBoxHeadingVisible(! isSmsBoxHeadingVisible)}><i className="icon-ellipsis font-medium-3"></i></a>
                                    <div className={`heading-elements ${isSmsBoxHeadingVisible ? 'visible' : ''}`}>
                                        <ul className="list-inline mb-0">
                                            <li><a data-action="collapse" id="btn-collapse-expand-box1"><i className={smsCollapsed ? "icon-minus4" : "icon-plus4"} onClick={handleSmsCollapsed}></i></a></li>
                                            <li><a data-action="expand"><i className="icon-expand2"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <Collapse in={smsCollapsed} className="card-body collapse in">
                                    <div className="card-block">
                                        <div className="form-body" style={{overflow: 'unset !important'}} >
                                            <p className="text-muted">
                                                شماره موبایل کاربر را وارد کنید
                                            </p>
                                            <div className="" style={{display: 'flex', justifyContent: 'space-between'}} >
                                                <input type="text" name="mobile" className="form-control" placeholder="09xxxxxxxxx"
                                                       id="input-mobile" style={{marginLeft: '15px', width: '190px'}}
                                                       value={mobile} onChange={handleNormalInput} />
                                                <br />
                                                <button type="submit" id="btn-send-code" className="btn btn-primary w-100" name="" value="" style={{marginRight: '15px'}} disabled={sendSmsBtnDisable} onClick={handleBtnSendCodeBySms} >{sendSmsBtnTxt}
                                                    <img src={AjaxLoader} width="24" id="ajax-loader-btn-send-code" className="ml-2" style={{display: "none"}} />
                                                </button>
                                            </div>

                                            <div id="segment-verify-code" className={isVisibleVerifySmsCode ? "show" : "hide"}  >
                                                <p className="text-muted mt-3" >
                                                    کد ارسال شده به موبایل کاربر را وارد کنید:
                                                </p>
                                                <div style={{display: 'flex', justifyContent: 'space-between'}} >
                                                    <input type="text" name="code" className="form-control" placeholder="xxxx"
                                                            id="input-verify-code" style={{marginLeft: '15px', width: '190px'}}
                                                            value={code} onChange={handleNormalInput} />


                                                    <br />
                                                    <button type="submit" id="btn-verify-code" className="btn btn-success w-100" name="add_discount" value="discount" disabled={smsBtnDisable} onClick={handleSubmitFormSms} style={{marginRight: '15px'}} >تایید
                                                        <img src={AjaxLoader} width="24" id="ajax-loader-btn-verify-code" className="ml-2" style={{display: 'none'}} />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Collapse>
                            </div>
                        </Col>
                    </Row>



                    <Row>
                        <div className="col-xs-12">

                            <div id="card-trans" className={`card ${isVisibleAddForm ? "show" : "hide"}`} style={{minHeight: 'unset !important', display: 'block'}} >
                                <div className="card-header">
                                    <h4 className="card-title">
                                        ثبت تراکنش <span id="span-mobile">{userMobile}</span> <span id="span-credit" style={{marginRight: '15px'}} >{`موجودی: ${userCredit !== null ? parseInt(userCredit).toLocaleString() : "0"} ریال`}</span>  <span id="span-time-remaining" style={{marginRight: '20px'}} >{timeRemaining}</span>
                                    </h4>
                                    <a className="heading-elements-toggle" onClick={() => setIsAddTransBoxHeadingVisible(! isAddTransBoxHeadingVisible)}><i className="icon-ellipsis font-medium-3"></i></a>
                                    <div className={`heading-elements ${isAddTransBoxHeadingVisible ? 'visible' : ''}`}>
                                        <ul className="list-inline mb-0">
                                            <li><a data-action="collapse"><i className={addFromCollapsed ? "icon-minus4" : "icon-plus4"} onClick={handleAddFormCollapsed}></i></a></li>
                                            <li><a data-action="expand"><i className="icon-expand2"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <Collapse in={addFromCollapsed} className="card-body collapse in">
                                    <div className="card-block">
                                        <div className="form-body" style={{overflow: 'unset !important'}} >

                                            <div className="row display-hidden">
                                                <div className="col-md-4">
                                                    <div className="card border-gray border-lighten-1">
                                                        <div className="p-1">
                                                            <p className="mb-0">
                                                                <small className="text-muted">نام کاربر</small>
                                                            </p>
                                                            <p className="mb-0" id="p-user-fullname">
                                                                {fullname}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="card border-gray border-lighten-1">
                                                        <div className="p-1">
                                                            <p className="mb-0">
                                                                <small className="text-muted">کدملی</small>
                                                            </p>
                                                            <p className="mb-0" id="p-user-nationalcode">
                                                                {nationalCode}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="card border-gray border-lighten-1">
                                                        <div className="p-1">
                                                            <p className="mb-0">
                                                                <small className="text-muted">موجودی کیف پول</small>
                                                            </p>
                                                            <p className="mb-0" id="p-user-credit">
                                                                {userCredit !== null ? parseInt(userCredit).toLocaleString() : '0'} ریال
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="form-group col-md-3">
                                                    <label htmlFor="cart-amount" style={{fontSize: 'smaller'}} ><span className="text-danger" >*</span> مبلغ سبد خرید (ریال) :</label>
                                                    <input type="text" id="cart-amount" className="form-control input-numeric" name="cartAmount" value={cartAmount} onChange={handelNumericInputs} placeholder="ریال" />
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <label htmlFor="drp-service" style={{fontSize: 'smaller'}} ><span className="text-danger" >*</span>نوع محصول یا خدمات:</label>
                                                    <select name="service" className="form-control" id="drp-service" value={service} onChange={handleNormalInput}>
                                                        { profile.services !== undefined && profile.services.length > 0 ?
                                                            profile.services.map((service, key) => {
                                                                return (
                                                                    <option value={service.id}>{service.title}</option>
                                                                );
                                                            })
                                                        :''}
                                                    </select>
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <label htmlFor="shop_share" style={{fontSize: 'smaller'}}>سهم فروشگاه: (ریال)</label>
                                                    <input id="shop_share" className="form-control input-numeric" name="shopShare" value={shopShare} onChange={handelNumericInputs} readonly="readonly" placeholder="ریال" />
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <label htmlFor="cash_back_amount" style={{fontSize: 'smaller'}}>مبلغ برگشت وجه (ریال)</label>
                                                    <input id="cash_back_amount" className="form-control input-numeric" name="cashBackAmount" value={cashBackAmount} onChange={handelNumericInputs} readonly="readonly" placeholder="ریال" />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="form-group col-md-3">
                                                    <label htmlFor="tracking_num" style={{fontSize: 'smaller'}}>شماره پیگیری</label>
                                                    <input id="tracking_num" className="form-control input-numeric" name="trackingNum" value={trackingNum} onChange={handleNormalInput} readonly="readonly" placeholder="" />
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <label htmlFor="product" style={{fontSize: 'smaller'}}><span className="text-danger">*</span> شماره فاکتور فروشگاه:</label>
                                                    <input id="input-factor-num" className="form-control" name="factorNum" value={factorNum} onChange={handleNormalInput} />
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="product" style={{fontSize: 'smaller'}}>توضیحات :</label>
                                                    <input id="input-desc" className="form-control" name="description" value={description} onChange={handleNormalInput} />
                                                </div>
                                            </div>


                                            <div className="form-actions" style={{display: 'flex'}} >
                                                <div style={{display: 'flex', flexDirection: 'column'}} >
                                                    <button type="submit" id="btn-reg_new_trans" className="btn btn-success" name="register_new_btn" value="register" disabled="disabled" style={{border: '1px solid #0100fe', backgroundColor: '#f6f5fa', color: '#0100fe'}} >
                                                        <i className="icon-plus4"></i> افزودن تراکنش محصول دیگر
                                                        <img src={AjaxLoader} width="24" id="ajax-loader-btn-register" className="ml-2" style={{display: 'none'}} />
                                                    </button>
                                                    <button type="submit" id="btn-reg" className="btn btn-success mt-1" name="register_btn" value="register" disabled={addTransBtnDisable} onClick={handleSubmitFormAddTrans}>
                                                        <i className="icon-check2"></i> ثبت
                                                        <img src={AjaxLoader} width="24" id="ajax-loader-btn-register" className="ml-2" style={ !addTransBtnDisable ? {display: 'none'} : null } />
                                                    </button>
                                                </div>
                                                    

                                                <span className="text-danger" id="warning-wallet" style={ !warningWalletShow ? {display: 'none', marginRight: '15px'} : {marginRight: '15px'} } >مبلغ بیشتر از موجودی کیف پول میباشد!</span>
                                            </div>

                                            <div className="row mt-2">
                                                <div className="form-group col-md-12 text-danger" id="div-validation-errors">
                                                    
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </Collapse>
                            </div>
                        </div>
                    </Row>




                </div>
            </div>
        </div>



    );
}

export default AddTrans;